/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2017 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
/* eslint no-throw-literal:0 */
import './types';
import * as domUtil from './core/DomUtil';
import * as envUtil from './core/EnvUtil';
import * as providerUtil from './core/ProviderUtil';
import * as cookieUtil from './core/CookieUtil';
import bindAndCatch from './core/bindAndCatch';
import Deferred from './core/Deferred';
import DcExtensionStorage from './core/DcExtensionStorage';
import globalContextManager from './core/GlobalContextManager';
import { auth2 } from './services/Auth2API';
import { locale2 } from './services/Locale2API';
import { logging } from './services/LoggingAPI';
import { addProvider, providers } from './services/Providers';
import { router } from './services/RouterAPI';
import { analytics } from './services/Analytics';
// eslint-disable-next-line import/named
import { discovery } from './services/Discovery';
import { webPlatform } from './services/WebPlatform';
import * as appConfigUtil from './core/AppConfigUtil';
import withHoc from './core/withHoc';
import { dcV3Theme } from './core/DcV3Theme';

const corePackage = CORE_PACKAGE;
const useAuthState = auth2.useAuthState.bind(auth2);

// Check that dc-core has been built properly
window.adobe_dc_sdk = window.adobe_dc_sdk || {} as any;
if (window.adobe_dc_sdk['dc-core-loaded']) {
  // normally this means that dc-core has been statically linked
  throw 'dc-core loaded twice';
}
window.adobe_dc_sdk['dc-core-loaded'] = true;

export {
  addProvider,
  analytics,
  appConfigUtil,
  auth2,
  bindAndCatch,
  cookieUtil,
  corePackage,
  DcExtensionStorage,
  dcV3Theme,
  Deferred,
  discovery,
  domUtil,
  envUtil,
  globalContextManager,
  locale2,
  logging,
  providers,
  providerUtil,
  router,
  useAuthState,
  webPlatform,
  withHoc,
};
